var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"news-card"},[_c('div',{staticClass:"up"},[_c('img',{attrs:{"src":_vm.imageUrl,"alt":"img"}}),_c('div',{staticClass:"down"},[_vm._v(" "+_vm._s(_vm.newTitle)+" ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }